import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MapPin } from "react-feather";

export default function PosMenuModal({ isOpen, onClose, onSelect, costCenter }) {
  const [menuList, setMenuList] = useState([]);

  useEffect(() => {
    if (isOpen && costCenter) {
      setMenuList(costCenter.Menus || []);
    } else {
      setMenuList([]);
    }
  }, [isOpen, costCenter]);

  if (!isOpen) return null;

  return (
    <div
      className="modal d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1055 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content p-4 rounded-4">

          {/* HEADER */}
          <div className="modal-header border-0">
            <h5 className="modal-title w-100 text-center">
              Select Menu {costCenter?.CostCenter ? `for ${costCenter.CostCenter}` : ""}
            </h5>
            <button className="btn-close" onClick={onClose} />
          </div>

          {/* BODY */}
          <div className="modal-body text-center">
            <div className="d-flex flex-wrap justify-content-center gap-4">

              {menuList.map((m) => (
                <div
                  key={m.MenuID}
                  className="category-card shadow-sm p-3 text-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onSelect(m.MenuName, m.MenuID);
                    onClose();
                  }}
                >
                  {/* Same icon style as location modal */}
                  <div>
                    <MapPin size={40} color="#39B9F0" />
                  </div>

                  <h6 className="mt-2">{m.MenuName}</h6>
                </div>
              ))}

              {menuList.length === 0 && (
                <p className="text-muted">No menus found</p>
              )}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

PosMenuModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  costCenter: PropTypes.object,
};
